export const formatExtension = (fileName: string = ""): string => {
  if (!fileName) {
    return "";
  }
  const matches = fileName.match(/^.+\.(\w+)$/);
  return matches ? matches[1] : "";
};
